import { DropdownMenu, MenuItem } from '@reckon-web/dropdown';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  LogOutIcon,
  RefreshCwIcon,
  UserIcon,
} from '@reckon-web/icon';
import { ActionButton } from '@reckon-web/button';
import { Flex } from '@reckon-web/flex';
import { UserAvatar } from '@reckon-web/avatar';
import { Tooltip } from '@reckon-web/tooltip';
import { Box } from '@reckon-web/box';
import { Inline } from '@reckon-web/inline';
import { Text } from '@reckon-web/text';
import { Stack } from '@reckon-web/stack';

import { signout, silentRefresh, useUser } from '../../auth';

const APPLICATION_VERSION = process.env.APPLICATION_VERSION;

type ProfileProps = {
  handleSetUserToUpdateId: (user: string | null) => void;
};

export const Profile = ({ handleSetUserToUpdateId }: ProfileProps) => {
  const user = useUser();

  const userName = user?.profile?.name ?? '';

  return (
    <DropdownMenu
      align="right"
      trigger={({ triggerProps, isOpen }) => (
        <ActionButton {...triggerProps} weight="subtle" id="user-avatar-button">
          <Flex alignItems="center" gap="small">
            <Tooltip content={userName}>
              <Box>
                <UserAvatar name={userName} size="small" />
              </Box>
            </Tooltip>
            {isOpen ? (
              <ChevronUpIcon size="small" />
            ) : (
              <ChevronDownIcon size="small" />
            )}
          </Flex>
        </ActionButton>
      )}
    >
      <Stack padding="large" align="center" gap="small">
        <UserAvatar name={user?.profile?.name} />
        <Stack gap="xsmall">
          <Text weight="bold" color="muted" align="center">
            {user?.profile?.name}
          </Text>
          <Text color="dim" align="center">
            {user?.profile?.email}
          </Text>
        </Stack>
      </Stack>
      <MenuItem
        id="header-button-manage-user"
        icon={UserIcon}
        onClick={() => handleSetUserToUpdateId(user?.profile?.staffId ?? null)}
        tone="active"
        label="Manage user"
      />
      {(process.env.NODE_ENV === 'development' ||
        localStorage.getItem('debugMode') === 'true') && (
        <MenuItem
          id="header-button-refresh-token"
          icon={RefreshCwIcon}
          onClick={() => silentRefresh()}
          tone="active"
          label="Refresh token"
        />
      )}
      <MenuItem
        id="logout-text-link"
        icon={LogOutIcon}
        onClick={() => signout()}
        tone="critical"
        label="Logout"
      />
      <Inline paddingX="large" paddingTop="small" alignY="center">
        <Text color="muted" size="xsmall">
          Version: {APPLICATION_VERSION}
        </Text>
      </Inline>
    </DropdownMenu>
  );
};
